export const BATCH_URL = 'payment-links/templates/payment-link-batch-template.csv';
